import React from "react";
import { TableBody } from "@material-ui/core";
import { stableSort, getComparator } from "../utils/SortList";

const TableContent = ({
  items = [],
  order = "",
  orderBy = "",
  page = 0,
  rowsPerPage = 5,
  children,
}) => {
  return (
    <TableBody>
      {stableSort(items, getComparator(order, orderBy))
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((item) => children(item))}
    </TableBody>
  );
};

export default TableContent;
